import { PlusIcon } from '@heroicons/react/20/solid';
import { TrashIcon } from '@heroicons/react/24/outline';
import CreateGlassItemModal from 'components/admin/modals/create-glass-item-modal';
import Button from 'components/inputs/button';
import NumberInput from 'components/inputs/number';
import Select from 'components/inputs/select';
import { GlassItemType } from 'data/types';
import { useState } from 'react';

type AdminGlassItem = {
  id: number;
  label: string;
  height: number;
  width: number;
  type: GlassItemType['fenestrationType'];
  material: GlassItemType['material'];
};

export default function GlassPage() {
  const [values] = useState<AdminGlassItem[]>([
    {
      id: 1,
      label: 'Small Window',
      height: 2,
      width: 2,
      type: 'Window',
      material: 'Clear Glass'
    },
    {
      id: 2,
      label: 'Medium Window',
      height: 4,
      width: 4,
      type: 'Window',
      material: 'Clear Glass'
    },
    {
      id: 3,
      label: 'Large Window',
      height: 6,
      width: 6,
      type: 'Window',
      material: 'Clear Glass'
    },
    {
      id: 4,
      label: 'French Door',
      height: 7,
      width: 6,
      type: 'French Door',
      material: 'Clear Glass'
    },
    {
      id: 5,
      label: 'Sliding Glass Door',
      height: 9,
      width: 4,
      type: 'Sliding Glass Door',
      material: 'Clear Glass'
    }
  ]);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className='mx-auto flex max-w-[1600px] flex-col gap-5'>
      <div className='text-3xl font-bold text-gray-900'>Glass/Doors</div>
      <table className='min-w-full divide-y divide-gray-300'>
        <thead>
          <tr>
            <th
              scope='col'
              className='pb-3.5 pl-0 pr-3 text-left font-semibold text-gray-900'
            >
              Item
            </th>
            <th
              scope='col'
              className='px-3 pb-3.5 text-left font-semibold text-gray-900'
            >
              Width
            </th>
            <th
              scope='col'
              className='px-3 pb-3.5 text-left font-semibold text-gray-900'
            >
              Height
            </th>
            <th
              scope='col'
              className='px-3 pb-3.5 text-left font-semibold text-gray-900'
            >
              Type
            </th>
            <th
              scope='col'
              className='px-3 pb-3.5 text-left font-semibold text-gray-900'
            >
              Material
            </th>
            <th
              scope='col'
              className='px-3 pb-3.5 text-left font-semibold text-gray-900'
            />
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200'>
          {values.map((item) => (
            <tr key={item.id}>
              <td className='whitespace-nowrap py-4 pl-0 pr-3 text-gray-900'>
                {item.label}
              </td>
              <td className='whitespace-nowrap px-3 py-4'>
                <div className='inline-block'>
                  <NumberInput
                    value={values.find((i) => i.id === item.id)?.width}
                    suffix=' ft'
                  />
                </div>
              </td>
              <td className='whitespace-nowrap px-3 py-4'>
                <div className='inline-block'>
                  <NumberInput
                    value={values.find((i) => i.id === item.id)?.height}
                    suffix=' ft'
                  />
                </div>
              </td>
              <td className='whitespace-nowrap px-3 py-4'>
                <div className='inline-block'>
                  <Select
                    value={values.find((i) => i.id === item.id)?.type}
                    options={[
                      'Window',
                      'Bay Window',
                      'French Door',
                      'Garden Window',
                      'Sliding Glass Door'
                    ]}
                  />
                </div>
              </td>
              <td className='whitespace-nowrap px-3 py-4'>
                <div className='inline-block'>
                  <Select
                    value={values.find((i) => i.id === item.id)?.material}
                    options={[
                      'Clear Glass',
                      'Glass or Plastic Block',
                      'Heat Absorbing Glass',
                      'Low-e Glass',
                      'Reflective Glass'
                    ]}
                  />
                </div>
              </td>
              <td className='px-3 py-4'>
                <TrashIcon className='h-5 w-5 shrink-0 cursor-pointer text-gray-500 hover:text-gray-700' />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='flex items-center gap-3'>
        <Button text='Save' color='green' />
        <Button
          text='New Glass Item'
          color='secondary'
          onClick={() => setModalOpen(true)}
          icon={PlusIcon}
        />
      </div>
      <CreateGlassItemModal openState={[modalOpen, setModalOpen]} />
    </div>
  );
}
